import { useNavigate } from "react-router"
import { WuKongBannerStyle } from "./style"
import { ContestDetailResponse } from "types/contest"
import { contestTabType } from "types/common"
import { hasToken } from "utils/functions/common"
import { loginPathWithRedirect } from "utils/functions/user"

const WuKongBanner = ({ detail }: { detail: ContestDetailResponse }) => {
    const tabList: contestTabType[] = [
        { name: "赛事详情", path: "/contest/wukong/detail", id: 1 },
        { name: "赛事规则", path: "/contest/wukong/rule", id: 2 },
        { name: "参赛作品", path: "/contest/wukong/work", id: 3 },
        { name: "赛果公示", path: "/contest/wukong/workprize", id: 4 }
    ]

    const token = hasToken()

    const navigate = useNavigate()

    const pathname = window.location.pathname

    const toApply = () => {
        if(!token) {
            navigate(loginPathWithRedirect())
            return
        }
        if (detail?.signupId === 0) {
            navigate(`/contest/apply/${detail.id}`)
        } else if (detail?.canUpload > 0) {
            navigate(`/contest/upload/${detail.id}`)
        }

    }

    const toDetail = (detail: any) => {
        navigate(detail.path)
    }
    return <WuKongBannerStyle>
        <img className="banner-img" src="https://cdn.ggac.com/img/wukong-pc-kv.png" alt="" />
        
        {
            detail?.canSignup === 1 && <div className="btn" onClick={toApply}>立即报名</div>
        }
        {
            detail?.canUpload === 1 && <div className="btn" onClick={toApply}>上传作品</div>
        }
         <div className="tip">赛事交流群：894719739</div>
          
        <div className="tab">
            {
                tabList.map(item => {
                    return <div key={item.id} onClick={() => toDetail(item)} className={`${pathname === item.path ? 'active ' : ''}tab-item`}>{item.name}</div>
                })
            }
        </div>
    </WuKongBannerStyle>
}

export default WuKongBanner